export const ID = 'report';
export const NAME = 'report';
